
import { Box, Typography, Button, Container, useTheme } from '@mui/material';
import { Link } from "react-router-dom";

const sections = [
    {
        bgColor: 'rgba(255, 255, 255, 0.36)',
        clip: 'polygon(0 0, 100% 5%, 100% 100%, 0 95%)',
        description: "Our technical expertise extends beyond our software offerings. We offer professional services in many areas like data integration, building dynamic reports, and validation to help any company tackle challenges in these specialized areas. Our team brings deep technical knowledge, a commitment to excellence, and a client-first approach to every project.Make your job easier by accessing key reports, integrating with key tools, ensuring a secure environment, storing data in a warehouse and much more. See our services offerings below:",
    },
    {
        image: '/insightsgrid.png',
        bgColor: 'rgba(116, 177, 233, 1)',
        clip: 'polygon(0 5%, 100% 0, 100% 95%, 0 100%)',

        //showButton: true,
        showimage: true,
    },
    {
        bgColor: 'rgba(255, 255, 255, 0.7)',
        clip: 'polygon(0 0, 100% 5%, 100% 100%, 0 95%)',
        title: 'READY TO SEE MORE?',

        showButton: true,
    },
];

const ProfessionalServicessection = () => {

    const theme = useTheme();


    return (
        <>
            <Box sx={{ py: 2, px: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography

                    sx={{
                        fontWeight: 'bold',
                        color: theme.palette.mode === "dark" ? "white" : "black",
                        fontSize: '1.5rem',
                        mb: 2,
                    }}
                >
                    PROFESSIONAL SERVICES
                </Typography>
                {/* <Typography
                    variant="h4"
                    sx={{
                        mb: 2,
                        fontSize: '1.2rem',
                        textAlign: 'center',
                        maxWidth: '800px',
                    }}
                >
                    The resource management tool to ensure you achieve clinical trial success within budget
                </Typography> */}


                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        justifyContent: { xs: 'center', md: 'flex-end' },
                        maxWidth: '100%',
                    }}
                >

                    <img
                        src="/studyProgressTracker.jpg"
                        alt="Click to play"

                        style={{
                            cursor: 'pointer',
                            borderRadius: '12px',
                            maxWidth: '1000px',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                            width: '100%',
                            height: '500px',
                        }}
                    />

                </Box>
            </Box>

            {sections.map((section, index) => (
                <Box
                    key={index}
                    sx={{
                        backgroundColor: section.bgColor,
                        clipPath: {
                            xs: 'none',
                            sm: 'none',
                            md:
                                index % 2 === 0
                                    ? 'polygon(0 0, 100% 20%, 100% 100%, 0 80%)'
                                    : 'polygon(0 20%, 100% 0, 100% 80%, 0 100%)',
                        },
                        position: 'relative',
                        zIndex: 10 - index,
                        mt: index === 0 ? 0 : '-90px',
                        py: { xs: 16, md: 12 },
                        px: { xs: 2, md: 6 },
                    }}
                >
                    <Container>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: {
                                    xs: 'column',
                                    md: index % 2 === 0 ? 'row' : 'row-reverse',
                                },
                                alignItems: 'center',
                                gap: 4,
                            }}
                        >
                            <Box
                                sx={{
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'left',
                                    px: { xs: 2, md: 8, mb: 20 },
                                }}
                            >
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: 'bold',
                                        color: theme.palette.mode === "dark" ? "white" : "black",
                                        mb: 4,
                                        fontSize: '1.5rem',
                                    }}
                                >
                                    {section.title}
                                </Typography>
                                {section.showButton && (
                                    <Button
                                        variant="contained"
                                        component={Link}
                                        to="/request-demo"
                                        sx={{
                                            backgroundColor: '#0081cc',
                                            color: '#FFFFFF',
                                            px: '40px',
                                            py: '6px',
                                            fontSize: '1.4rem',
                                            borderRadius: '50px',
                                            textTransform: 'none',
                                            fontWeight: 500,
                                            boxShadow: '0px 4px 12px rgba(0, 174, 239, 0.4)',
                                            transition: 'transform 0.3s ease, background-color 0.3s ease',
                                            '&:hover': {
                                                backgroundColor: '#0081cc',
                                                transform: 'scale(1.05)',
                                            },
                                            mb: 4,
                                        }}
                                    >
                                        Fill Out and We’ll Reach Out
                                    </Button>
                                )}

                                {section.paragraphs
                                    ? section.paragraphs.map((para, idx) => {
                                        const match = para.split("–");
                                        const boldPart = match[0] || "";
                                        const rest = match.slice(1).join("–");

                                        return (
                                            <Box
                                                key={idx}
                                                sx={{
                                                    width: "100%",
                                                    display: "block",
                                                    textAlign: "left",
                                                    mb: 2,
                                                }}
                                            >
                                                <Typography
                                                    variant="body1"
                                                    sx={{

                                                        fontSize: "1rem",
                                                        fontFamily: "Montserrat, sans-serif",
                                                        color: theme.palette.mode === "dark" ? "white" : "black",
                                                    }}
                                                >
                                                    <strong>{boldPart.trim()}</strong>
                                                    {rest ? " – " + rest.trim() : ""}
                                                </Typography>
                                            </Box>
                                        );
                                    })
                                    : (
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                mb: section.showButton ? 4 : 0,
                                                textAlign: "left",
                                                px: 4,
                                                fontSize: "1rem",
                                                fontFamily: "Montserrat, sans-serif",
                                                color: theme.palette.mode === "dark" ? "white" : "black",
                                            }}
                                        >
                                            {section.description}
                                        </Typography>
                                    )}
                                {section.showimage && (

                                    <img
                                        src="/Professional.png" // replace with your image
                                        alt="Click to play"

                                        style={{
                                            cursor: 'pointer',
                                            borderRadius: '12px',
                                            
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                                            width: '100%',
                                            height: '440px',
                                            marginBottom: '20px'
                                        }}
                                    />
                                )}

                            </Box>

                        </Box>
                    </Container>
                </Box>
            ))}
        </>
    );
};

export default ProfessionalServicessection;
